var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favourite button__container button__circle--white",class:{button__circle : _vm.haveBg}},[_c('img',{staticClass:"favourite__icon",attrs:{"src":_vm.heartIcon,"alt":"Add song to favourite - heart icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }